import { ShopKey } from "@secureo/common/typings/Shop"

const attributeName = "excludedShopCodes"

const attributeDoesNotExist = `masterData(current(masterVariant(not(attributes(name=\\"${attributeName}\\")))))`

export const getWhereConditionForExcludedShopCodesKeyNotIn = (notIn: ShopKey[]) => {
	const keyValue = notIn.map((shopCode) => `\\"${shopCode}\\"`).join(", ")

	const notInAttribute = `masterData(current(masterVariant(attributes(name=\\"${attributeName}\\" and value(key not in (${keyValue}))))))`

	return `(${notInAttribute} or ${attributeDoesNotExist})`
}
